(() => {
  if (customElements.get('reviews-showcase')) return;

  class ReviewsShowcase extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-reviews-more]');
      this.button?.addEventListener('click', () => {
        this.classList.add('is-expanded');
        this.button.setAttribute('aria-expanded', 'true');
        this.querySelector('[data-review-first-more]')?.focus({ preventScroll: false });
        window.theme?.initReveal?.(this);
      });
    }
  }

  customElements.define('reviews-showcase', ReviewsShowcase);
})();
